import type { Permission } from '@immo/api-contract';

/** A contract leaf, or a rule from `non-route-rules.ts` — anything that names the permission a gate answers to. */
export type PermissionSource = { readonly permission: Permission };

export type RouteGate<ReasonKey extends string = string> =
  { readonly disabled: false } | { readonly disabled: true; readonly reasonKey: ReasonKey };

/**
 * May the viewer call this route? `permissions` is the viewer's effective set in the
 * Standort the request will be addressed to — the caller resolves which Standort that is.
 */
export function mayCall(permissions: ReadonlyArray<string>, source: PermissionSource): boolean {
  return source.permission === 'PUBLIC' || permissions.includes(source.permission);
}

/** The same answer in the shape a visible control consumes: disabled, and why. */
export function routeGate<ReasonKey extends string>(
  permissions: ReadonlyArray<string>,
  source: PermissionSource,
  reasonKey: ReasonKey,
): RouteGate<ReasonKey> {
  return mayCall(permissions, source) ? { disabled: false } : { disabled: true, reasonKey };
}
